<template>
    <div class="content-wrapper">
        <app-page-top-section
            :title="$t('orders')"
        />

        <app-table
                id="orders-table"
                :options="options"
                @action="triggerActions"
                :search="orderNumber"
        />
    </div>
</template>

<script>
    import OrderMixin from "../../Mixins/OrderMixin";

    export default {
        name: "Orders",
        props: {
            orderNumber: {
                type: String,
                default: '',
            }
        },
        mixins: [OrderMixin],
        methods: {
            triggerActions(row, action, active) {
                window.open(`/admin/orders/${row.id}/invoices`, '_blank')
            }
        }
    }
</script>

<style scoped>

</style>